import React, { useContext } from 'react';
import { NavLink, Link } from 'react-router-dom';
import '../TaskCard/TaskCard.css';



const LockedTaskCard = ({ title, description, data, deadline, progress}) => {

    const getDeadlineColor = (deadline) => {

        switch (deadline) {

            case 4:
                return '#22C532'
            case 3:
            case 2:

                return '#F6C71E'
            case 1:
                return '#FF0000'

            default:
                return ''
        }
    }


    // console.log(description)
    return (

         <div className='lockedTaskCard__container'>
            <div className='lockedTaskCard'>
                <div className='lockedTaskCard__pic'/>
            </div>
            <div className='taskCard__header'>
                <div className={`${data ? 'taskCard__percentage' : 'taskCard__type'}`}>{'Тест'}</div>
                <div className='taskCard__tips'>
                    {deadline && <div className='taskCard__deadline' style={{ background: getDeadlineColor(deadline) }}>{`${deadline} дн.`}</div>}
                    {progress && <div className='taskCard__attempts'>{`${progress}`}</div>}
                </div>

            </div>
            <div className='taskCard__title'>{title}</div>
            <div className='taskCard__description'>{description ? description : ''}</div>
        </div>

    )
}
export default LockedTaskCard
